import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminProvider } from './context/AdminContext';
import Home from './pages/Home';
import Contact from './pages/Contact/Contact';
import FaisalContact from './pages/FaisalContact/FaisalContact';
import './styles/global.css'
import ProjectPrompt from './pages/ProjectPrompt/ProjectPrompt';
import MoreProducts from './pages/MoreProducts/MoreProducts';
import SubmissionSuccess from './pages/SubmissionSuccess/SubmissionSuccess';
import ShopifyAccountingSystem from './pages/ShopifyAccountingSystem/ShopifyAccountingSystem';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import About from './pages/About/About';
import Process from './pages/Process/Process';
import Testimonials from './pages/Testimonials/Testimonials';
import Careers from './pages/Careers/Careers';
import WebDevelopment from './pages/WebDevelopment/WebDevelopment';
import MobileDevelopment from './pages/MobileDevelopment/MobileDevelopment';
import AIPoweredTools from './pages/AIPoweredTools/AIPoweredTools';
import UIX from './pages/UIX/UIX';
import MVPPrototyping from './pages/MVPPrototyping/MVPPrototyping';
import HowItWorks from './pages/HowItWorks/HowItWorks';
import Blog from './pages/Blog/Blog';
import PromptExample from './pages/PromptExample/PromptExample';
import FAQ from './pages/FAQ/FAQ';
import IVisaService from './pages/IVisaService/IVisaService';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import AppsPrivacy from './pages/AppsPrivacy/AppsPrivacy';
import AdminLogin from './pages/CMS/AdminLogin/AdminLogin';
import AdminDashboard from './pages/CMS/AdminDashboard/AdminDashboard';
import ProtectedRoute from './components/CMS/ProtectedRoute/ProtectedRoute';

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faisal_contact" element={<FaisalContact />} />
          <Route path="/project_prompt" element={<ProjectPrompt />} />
          <Route path="/more_products" element={<MoreProducts />} />
          <Route path="/submission-success" element={<SubmissionSuccess />} />
          <Route path="/shopify-accounting-system" element={<ShopifyAccountingSystem />} />
          <Route path="/about" element={<About />} />
          <Route path="/process" element={<Process />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/services/web" element={<WebDevelopment />} />
          <Route path="/services/mobile" element={<MobileDevelopment />} />
          <Route path="/services/ai-tools" element={<AIPoweredTools />} />
          <Route path="/services/ui-ux" element={<UIX />} />
          <Route path="/services/mvp" element={<MVPPrototyping />} />
          <Route path="/resources/how-it-works" element={<HowItWorks />} />
          <Route path="/resources/prompts" element={<PromptExample />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/i-visa-service" element={<IVisaService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/apps-privacy" element={<AppsPrivacy />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AdminProvider>
  );
}

export default App;
